import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// Action Creators
export const fetchLogout = () => ({
  type: LOGOUT,
});

export const fetchLogoutSuccess = (data) => ({
  type: LOGOUT_SUCCESS,
  payload: data,
});

export const fetchLogoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  payload: error,
});

// Thunk Function
export const logoutCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchLogout(data, external));
    try {
      const response = await postMethodWithToken(url.logout, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchLogoutSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchLogoutFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchLogoutFailure(error.message));
    }
  };
};
